import React from "react"
import moment from "moment"
import { useTranslation } from "react-i18next"
import DataField from "../../utils/DataField"
import AnalysisStatus from "../AnalysisStatusBox/AnalysisStatus/AnalysisStatus"
import { titleCase, clientAge, formatAddress, formatPhone, translateGender, translateClientType, translatePhoneType } from "../../utils/utils"
import { partyFraudStatus } from "./partyStatus"

function PartyDetailsSheet(props) {
    const { t } = useTranslation()
    const party = props.party
    if (party == null) return null

    const phones = Array.isArray(party.phones) ? party.phones : []
    const phonesLabel = phones.length > 0
        ? phones.map((phone) => translatePhoneType(phone.type) + ": " + formatPhone(phone, "-")).join(" | ")
        : "-"
    const documents = party.documents || {}
    const rg = documents.rg
    const cnh = documents.cnh
    const rgLabel = rg && rg.document_number ? rg.document_number + (rg.issuer ? " - " + rg.issuer : "") : "-"
    const cnhLabel = cnh && cnh.document_number ? cnh.document_number + (cnh.state ? " - " + cnh.state : "") : "-"
    const cnhExpirationLabel = cnh && cnh.expiration_date ? moment(cnh.expiration_date).format("DD/MM/YYYY") : "-"

    return (
        <div className="labelSpace" data-dd-privacy="mask">
            <AnalysisStatus name={t("analysis_status")} status={partyFraudStatus(party)} />
            <DataField title={t("name")} label={titleCase(party.name, "-")} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("client_type")} label={party.type ? translateClientType(party.type) : "-"} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("document_number")} label={party.documentNumber || "-"} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("birthdate")} label={clientAge(party.birthdate, "-")} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("gender")} label={party.gender ? translateGender(party.gender) : "-"} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("mother_name")} label={titleCase(party.motherName, "-")} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("email")} label={party.email || "-"} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("phones")} label={phonesLabel} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("residential_address")} label={formatAddress(party.residentialAddress, "-")} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("commercial_address")} label={formatAddress(party.commercialAddress, "-")} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("segment")} label={party.segment || "-"} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("total_rents")} label={party.totalRents == null ? "-" : String(party.totalRents)} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("rg")} label={rgLabel} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("cnh")} label={cnhLabel} size="normalMediumSize" titleNoWrap={true} margin="10px" />
            <DataField title={t("expiration_date")} label={cnhExpirationLabel} size="normalMediumSize" titleNoWrap={true} margin="10px" />
        </div>
    )
}

export default PartyDetailsSheet
